import Splide from '@splidejs/splide';

const HeaderAnchorLinkMenu = (header) => {
    const anchorLinkMenu = header.querySelector('.anchor-menu');
    if (anchorLinkMenu) {
        const anchorLinks = document.querySelectorAll('[data-anchor-menu]');
        const splideList = anchorLinkMenu.querySelector('.splide__list');
        if (splideList) {
            anchorLinks.forEach((tag, i) => {
                if (!tag.getAttribute('id')) return;
                if (tag.dataset.anchorMenu == '') return;
                const slide = document.createElement('div');
                slide.classList.add('splide__slide');
                const link = document.createElement('a');
                link.classList.add('anchor-menu__link');
                link.href = `#${tag.getAttribute('id')}`;
                link.innerText = tag.dataset.anchorMenu;
                if (i === 0) {
                    link.classList.add('active');
                }
                slide.appendChild(link);
                splideList.appendChild(slide);
            })

            const anchorLinkSlider = new Splide( anchorLinkMenu.querySelector('.splide'), {
                autoWidth: true,
                gap: 16,
                pagination: false,
                arrows: false,
            } ).mount( {} );
            const forceResizeEvent = new CustomEvent('forceResizeEvent', {});
            document.dispatchEvent(forceResizeEvent);

            const anchorMenuLinks = anchorLinkMenu.querySelectorAll('.anchor-menu__link');
            const sections = Array.from(anchorLinks);
            
            let lastScrollY = window.scrollY;
            let activeIndex = -1;

            const setActive = (index) => {
                if (index === activeIndex || index < 0) return;
            
                activeIndex = index;
            
                anchorMenuLinks.forEach(link => link.classList.remove('active'));
            
                const section = sections[index];
                const activeLink = anchorLinkMenu.querySelector(
                    `.anchor-menu__link[href="#${section.id}"]`
                );
            
                if (activeLink) {
                    activeLink.classList.add('active');
                    anchorLinkSlider.go(index);
                }
            };

            window.addEventListener('scroll', () => {
                const scrollY = window.scrollY;
                const scrollingDown = scrollY > lastScrollY;
                const headerHeight = parseInt(window.getComputedStyle(document.body).getPropertyValue('--header-height'), 10);
                
                sections.forEach((section, i) => {
                    const offset = section.offsetTop - headerHeight;
                    if (scrollingDown) {
                        if (scrollY >= offset - 24 && i > activeIndex) {
                            setActive(i);
                        }
                    } else {
                        if (scrollY <= offset + 24 && i < activeIndex) {
                            setActive(i);
                        }
                    }
                });

                lastScrollY = scrollY;
            });
        }
    }
}

export default HeaderAnchorLinkMenu;
